import { AddressUnit } from '@/api/placeToVisit'
import { getCountryLabel } from './countries'

export function formatAddress(address?: AddressUnit, lang = 'fr'): string {
  if (address) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return `${[address.address, address.addressComplement1, address.addressComplement2].filter(el => el).map(el => `${el!.trim()}, `).join('')}${address.zip} - ${address.town} (${getCountryLabel(address.country, lang)})`
  } else {
    return ''
  }
}
